import React from 'react';
import { AlertTriangle, X, Info, AlertCircle } from 'lucide-react';
import { Alert } from '../../types/dashboard';
interface AlertBannerProps {
  alerts: Alert[];
  onDismiss: (id: string) => void;
}
export function AlertBanner({
  alerts,
  onDismiss
}: AlertBannerProps) {
  if (alerts.length === 0) return null;
  return <div className="space-y-2 mb-6" data-id="element-1">
      {alerts.map(alert => <div key={alert.id} className={`flex items-center justify-between p-4 rounded-lg border-l-4 shadow-sm animate-in fade-in slide-in-from-top-2 duration-300 ${alert.type === 'critical' ? 'bg-rose-50 border-rose-500 text-rose-900' : alert.type === 'warning' ? 'bg-amber-50 border-amber-500 text-amber-900' : 'bg-blue-50 border-blue-500 text-blue-900'}`} data-id="element-2">
          <div className="flex items-center gap-3" data-id="element-3">
            {alert.type === 'critical' && <AlertCircle className="w-5 h-5 text-rose-600" data-id="element-4" />}
            {alert.type === 'warning' && <AlertTriangle className="w-5 h-5 text-amber-600" data-id="element-5" />}
            {alert.type === 'info' && <Info className="w-5 h-5 text-blue-600" data-id="element-6" />}
            <div data-id="element-7">
              <span className="font-semibold mr-2" data-id="element-8">
                {alert.type === 'critical' ? 'CRITICAL ACTION REQUIRED:' : alert.type === 'warning' ? 'WARNING:' : 'UPDATE:'}
              </span>
              <span data-id="element-9">{alert.message}</span>
              <span className="ml-3 text-xs opacity-70 font-mono" data-id="element-10">
                {alert.timestamp}
              </span>
            </div>
          </div>
          <button onClick={() => onDismiss(alert.id)} className="p-1 hover:bg-black/5 rounded-full transition-colors" data-id="element-11">
            <X className="w-4 h-4" data-id="element-12" />
          </button>
        </div>)}
    </div>;
}